/**
 * @file Floating labels stay floated after leaving input field in case that some text was entered
 * @author michael.schmid@notch-interactive.com
 *
 * @module components/floating-label
 *
 */

import pubsub from '../libs/pubsub';

const instance = {},

    /**
     *
     * @typedef defaults
     */

    defaults = {
        // TODO: Remove .m-form namespacing and make it more modular
        inputField: '.m-form input[type="text"], .m-form input[type="password"], .m-form input[type="tel"], .m-form input[type="email"], .m-form textarea',
        enteredContentClass: 'has-entered-content',
        boundAttr: 'data-form-bound'
    };

let settings,
    inputFields,
    uidDesktopNav,
    uidMobileNav,

    toggleEnteredContentClass = (e) => {
        let target = e.target;
        if (target.value === '') {
            target.classList.remove(settings.enteredContentClass);
        } else {
            target.classList.add(settings.enteredContentClass);
        }
    },

    // This should slightly improve performance.
    focusHandler = e => {
        let input = e.target,
            label = input.nextElementSibling;

        if (label && label.tagName.toUpperCase() === 'LABEL' && !input.classList.contains(settings.enteredContentClass)) {

            label.style.willChange = 'transform, font-size';
            label.addEventListener('transitionend', function transitionHandler() {
                label.style.willChange = '';
                label.removeEventListener('transitionend', transitionHandler);
            });
        }
    },

    checkAllFields = () => {
        inputFields.forEach((inputField) => {
            if (inputField.value === '') {
                inputField.classList.remove(settings.enteredContentClass);
            } else {
                inputField.classList.add(settings.enteredContentClass);
            }
        });
    },

    // Waiting can be necessary to wait for browser to autofill login form eg.
    checkAllFieldsDelayed = (delayInMs) => {
        const delay = delayInMs || 1000;
        setTimeout(
            function () {
                checkAllFields();
            }, delay);
    };

const bindEvents = () => {
        inputFields.forEach((inputField) => {

            // Set the bound Attribute, so that this module doesn't initiate the factory multiple times over the same elements
            inputField.setAttribute(settings.boundAttr, '');
            inputField.addEventListener('blur', toggleEnteredContentClass);
            inputField.addEventListener('focus', focusHandler);
        });

        uidDesktopNav = pubsub.on('desktopnav.open', instance.checkAllFieldsDelayed);
        uidMobileNav = pubsub.on('mobilenav.open', instance.checkAllFieldsDelayed);
    },

    unbindEvents = () => {
        inputFields.forEach((inputField) => {

            // Set the bound Attribute, so that this module doesn't initiate the factory multiple times over the same elements
            inputField.removeAttribute(settings.boundAttr);
            inputField.removeEventListener('blur', toggleEnteredContentClass);
            inputField.removeEventListener('focus', focusHandler);
        });

        pubsub.off(uidDesktopNav);
        pubsub.off(uidMobileNav);
    };

/**
 * Initialize module
 *
 * @param {object} options - Override default settings with options object.
 * @return {object} Instance of created module.
 */

instance.init = options => {
    settings = Object.assign({}, defaults, options);

    inputFields = [...document.querySelectorAll(settings.inputField + ':not([' + settings.boundAttr + '])')];

    bindEvents();
    checkAllFields();

    setTimeout(checkAllFields, 750); // Check again, for autofill timing issue
    setTimeout(checkAllFields, 1500); // Check again, for autofill timing issue

    return instance;
};

instance.checkAllFields = checkAllFields;
instance.checkAllFieldsDelayed = checkAllFieldsDelayed;

/**
 * Destroy this module.
 */

instance.destroy = () => {
    unbindEvents();
};

export default instance;
